import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import postService from "./postService";

const initialState = {
  post: null,
  posts: [],
  icymiPosts: [],
  relatedPosts: [],
  upNextPosts: [],
  mostRead: [],
  trendyPosts: [],
  hotNews: [],
  // articles: [],
  comments: [],
  category: [],
  isError: false,
  isLoading: false,
  message: "",
};

// Create Product
export const createPost = createAsyncThunk(
  "posts/createPost",
  async (formData, thunkAPI) => {
    try {
      return await postService.createPost(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Products
export const getPosts = createAsyncThunk(
  "posts/getPosts",
  async (_, thunkAPI) => {
    try {
      return await postService.getPosts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get getICYMIPosts
export const getICYMIPosts = createAsyncThunk(
  "posts/getICYMIPosts",
  async (_, thunkAPI) => {
    try {
      return await postService.getICYMIPosts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// getRelatedPosts
export const getRelatedPosts = createAsyncThunk(
  "posts/getRelatedPosts",
  async (slug, thunkAPI) => {
    try {
      return await postService.getRelatedPosts(slug);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// getUpNextPosts
export const getUpNextPosts = createAsyncThunk(
  "posts/getUpNextPosts",
  async (slug, thunkAPI) => {
    try {
      return await postService.getUpNextPosts(slug);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete Product
export const deletePost = createAsyncThunk(
  "posts/deletePost",
  async (id, thunkAPI) => {
    try {
      return await postService.deletePost(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Product
export const getPost = createAsyncThunk(
  "posts/getPost",
  async (id, thunkAPI) => {
    try {
      return await postService.getPost(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get mostReadPost
export const getMostReadPosts = createAsyncThunk(
  "posts/getMostReadPosts",
  async (_, thunkAPI) => {
    try {
      return await postService.getMostReadPosts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get mostReadPost
export const getTrendyPosts = createAsyncThunk(
  "posts/getTrendyPosts",
  async (_, thunkAPI) => {
    try {
      return await postService.getTrendyPosts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get mostReadPost
export const getHotNews = createAsyncThunk(
  "posts/getHotNews",
  async (_, thunkAPI) => {
    try {
      return await postService.getHotNews();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update Product
export const updatePost = createAsyncThunk(
  "posts/updatePost",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await postService.updatePost(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// addComment
export const addComment = createAsyncThunk(
  "posts/addComment",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await postService.addComment(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// addComment
export const addLike = createAsyncThunk(
  "posts/addLike",
  async (id, thunkAPI) => {
    try {
      return await postService.addLike(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// removeComment
export const removeLike = createAsyncThunk(
  "posts/removeLike",
  async (id, thunkAPI) => {
    try {
      return await postService.removeLike(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// reviewProduct
export const reviewPost = createAsyncThunk(
  "posts/reviewPost",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await postService.reviewPost(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// deleteReview
export const deleteReview = createAsyncThunk(
  "posts/deleteReview",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await postService.deleteReview(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// updateReview
export const updateReview = createAsyncThunk(
  "posts/updateReview",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await postService.updateReview(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    RESET_PROD(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      // create Product
      .addCase(createPost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        // console.log(action.payload);
        if (action.payload && action.payload.hasOwnProperty("message")) {
          toast.error(action.payload.message);
        } else {
          state.message = "Post created Successful";
          toast.success("Post created Successful");
        }
      })
      .addCase(createPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get Products
      .addCase(getPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.posts = action.payload;
        // console.log(action.payload);
      })
      .addCase(getPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // toast.error(action.payload);
      })

      // Get getICYMIPosts
      .addCase(getICYMIPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getICYMIPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.icymiPosts = action.payload;
        // console.log(action.payload);
      })
      .addCase(getICYMIPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // toast.error(action.payload);
      })

      // getRelatedPosts
      .addCase(getRelatedPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRelatedPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.relatedPosts = action.payload;
        // console.log(action.payload);
      })
      .addCase(getRelatedPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // toast.error(action.payload);
      })

      // getUpNextPosts
      .addCase(getUpNextPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUpNextPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.upNextPosts = action.payload;
        // console.log(action.payload);
      })
      .addCase(getUpNextPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // toast.error(action.payload);
      })

      // Delete Product
      .addCase(deletePost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success("Post deleted successfully");
      })
      .addCase(deletePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get Product
      .addCase(getPost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.post = action.payload;
        // console.log(action.payload);
      })
      .addCase(getPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get Product
      .addCase(getMostReadPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMostReadPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.mostRead = action.payload;
        // console.log(action.payload);
      })
      .addCase(getMostReadPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get getTrendyPosts
      .addCase(getTrendyPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTrendyPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.trendyPosts = action.payload;
        // console.log(action.payload);
      })
      .addCase(getTrendyPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get getHotNews
      .addCase(getHotNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHotNews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.hotNews = action.payload;
        // console.log(action.payload);
      })
      .addCase(getHotNews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Update Post
      .addCase(updatePost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        console.log(action.payload);
        if (action.payload && action.payload.hasOwnProperty("message")) {
          toast.error(action.payload.message);
        } else {
          state.message = "Post updated Successful";
          toast.success("Post updated Successful");
        }
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // addComment
      .addCase(addComment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.comments = action.payload;
        toast.success(action.payload);
      })
      .addCase(addComment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // addLike
      .addCase(addLike.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addLike.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.comments = action.payload;
        // toast.success(action.payload);
      })
      .addCase(addLike.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // removeLike
      .addCase(removeLike.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(removeLike.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.comments = action.payload;
        // toast.success(action.payload);
      })
      .addCase(removeLike.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // reviewProduct
      .addCase(reviewPost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(reviewPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success(action.payload);
      })
      .addCase(reviewPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // deleteReview
      .addCase(deleteReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteReview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success(action.payload);
        console.log(action.payload);
      })
      .addCase(deleteReview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
        // console.log(action.payload);
      })

      // updateReview
      .addCase(updateReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateReview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success(action.payload);
      })
      .addCase(updateReview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      });
  },
});

export const { RESET_PROD, GET_PRICE_RANGE } = postSlice.actions;

export const selectPost = (state) => state.post.post;
export const selectPosts = (state) => state.post.posts;
export const selectComments = (state) => state.post.comments;
export const selectIsLoading = (state) => state.post.isLoading;

export default postSlice.reducer;
